export default "__VITE_ASSET__5ed7379f__"